import { SVGProps } from './SVGProps';

const XClose = ({ fill = 'white', width = '24', height = '24', stroke, ...rest }: SVGProps) => {
  return (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <g id="x-close">
        <path
          id="Icon"
          d="M18 6L6 18M6 6L18 18"
          stroke={stroke}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};

export default XClose;
